<template>
  <div class="bodyDiv">
    <div class="header">
      <div class="headCenter Center1200">
        <div class="headCenter Center1200">
          <div class="logo">
            <img src="http://open.beijing.gov.cn/common/images/icon/opbj.png">
          </div>
          <div>北京商务服务发展地图</div>
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" style="margin-left: 20px;height: 59px">
            <el-menu-item index="1">国际化发展</el-menu-item>
            <el-menu-item index="2">北京市布局</el-menu-item>
          </el-menu>
        </div>
        <el-dropdown style="cursor:pointer;">
          <span class="el-dropdown-link" style="display: flex;align-items: center;">
            <el-avatar icon="el-icon-user-solid"></el-avatar>
            <p style="color: white;margin-left: 10px;">{{userName.account}}</p>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <span @click="handleClick('signOut')">安全退出</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span @click="handleClick('Back')">用户中心</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <nav class="headCenter Center1200">
      <img src="@/assets/ding.png" style="margin-right: 20px;">
      <Crumbs :Nav="JSON.stringify(Nav)"></Crumbs>
    </nav>
    <div  class="mapDiv" id="mapDiv"></div>
    <div class="context Center1200">
      <el-form :rules="rules" :model="form" ref="form" label-width="180px"  label-position="right">
        <el-form-item label="企业名称：" class="width45" prop="name">
          <el-input v-model="form.name" placeholder="请输入企业名称"></el-input>
        </el-form-item>

        <el-form-item label="行业类别：" class="width45" prop="industryType">
          <el-select v-model="form.industryType" placeholder="————请选择————">
            <el-option v-for="(item,Key) in categoryList" :key="Key" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属区域：" class="width45" prop="district">
          <el-select v-model="form.district" placeholder="————请选择————">
            <el-option v-for="(item,Key) in districtList" :key="Key" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="联系人：" class="width45" prop="contact">
          <el-input v-model="form.contact" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>

        <el-form-item label="联系方式：" class="width45" prop="contactNum">
          <el-input v-model="form.contactNum" placeholder="请输入联系方式"></el-input>
        </el-form-item>

        <el-form-item label="详细地址：" class="width45" prop="address">
          <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>

        </el-form-item>

        <el-form-item label="企业简介：" class="width90" prop="info">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" placeholder="请输入企业简介" v-model="form.info"></el-input>
        </el-form-item>

        <el-form-item label="主要业务：" class="width90" prop="business">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" placeholder="请输主要业务" v-model="form.business"></el-input>
        </el-form-item>

        <el-form-item label="典型案例：" class="width90" prop="typical">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" placeholder="请输入典型案例" v-model="form.typical"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="$router.back(-1)">取消</el-button>
          <el-button type="primary" @click="submitEntInfo()">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import {
  industriesApi,
  districtsApi,
  AddApi
  } from "@/api/ent2/EntAdd";
import {infoApi} from "@/api/ent2/EntInfo";
import Crumbs from '@/components/crumbs.vue';

export default {
  name: "EntAdd",
  components:{
    Crumbs
  },
  data() {
    return {
      userName: '',
      activeIndex: '2',
      Nav:[{//面包屑
        name:'北京市发展地图'
      },{
        name:'企业信息录入'
      }],
      form: {//表单提交需要的参数
        name: '',//企业名称
        industryType: '',//行业类别
        district: '',//所属区域
        contact: '',//联系人
        contactNum: '',//联系方式
        entCountryCodes:[],//国家和地区
        info: '',//企业简介
        business: '',//主要业务
        typical: '',//典型案例
        coverage: ''//业务服务覆盖的国家和地区
      },
      categoryList:[],//全部行业
      districtList:[],//北京地区
      rules: {
        name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        industryType: [
          { required: true, message: '请选择行业类别', trigger: 'change' }
        ],
        district: [
          { required: true, message: '请选择所属区域', trigger: 'change' }
        ],
        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactNum: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'change' }
        ],
        info: [
          { required: true, message: '请输入企业简介', trigger: 'blur' }
        ],
        business: [
          { required: true, message: '请输入主要业务', trigger: 'blur' }
        ],
        typical: [
          { required: true, message: '请输入典型案例', trigger: 'blur' }
        ]
      },
      Str: ''
    }
  },
  created(){
    if( this.$route.query.id != undefined) {
      infoApi({
        params:{
          entId:this.$route.query.id
        }
      }).then((res) => {//获取详情
        if (res.status == 200) {
          res.data.data.business = this.replaceAll(res.data.data.business, '<p>', '')
          res.data.data.business = this.replaceAll(res.data.data.business, '</p>', '')
          res.data.data.info = this.replaceAll(res.data.data.info, '<p>', '')
          res.data.data.info = this.replaceAll(res.data.data.info, '</p>', '')
          res.data.data.typical = this.replaceAll(res.data.data.typical, '<p>', '')
          res.data.data.typical = this.replaceAll(res.data.data.typical, '</p>', '')
          this.form = res.data.data
          this.form.id = this.$route.query.id
        }
      });
    }
    this.userName = JSON.parse(sessionStorage.getItem('user'))
    industriesApi().then((res) => {//获取全部行业
      this.categoryList = res.data.data
    });
    districtsApi().then((res) => {//获取北京地区
      this.districtList = res.data.data.slice(1);
    });
  },
  methods: {
    replaceAll(StringVal, preVal, replaceVal) {
      return StringVal.replace(new RegExp(preVal,'g'), replaceVal)
    },
    handleClick(type){
      if(type == 'signOut'){
        sessionStorage.clear();
        window.location.href = '/web/userCenter/'
      }else{
        window.location.href = '/web/userCenter#/Usercenter'
      }
    },
    IphoneMessage(rule,value,cb){
      let Iphone = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if(Iphone.test(value)){
        return cb();
      }
      cb('请输入合法手机号/电话号');
    },
    submitEntInfo() {
      this.AMapAct = new AMap.Map("mapDiv", {
        resizeEnable: true,
        zoom: 9
      });
      this.geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
      });
      let that = this;
      let data = JSON.parse(JSON.stringify(that.form));
      this.$refs.form.validate((valid) => {
        if (valid) {
          data.info = that.SplitStr(data.info);
          data.business = that.SplitStr(data.business);
          data.typical = that.SplitStr(data.typical);
          this.geocoder.getLocation(data.address, function(status, result) {
            if (status === 'complete' && result.geocodes.length) {
              var lnglat = result.geocodes[0].location
              data.addressLatitude = String(lnglat.lng)
              data.addressLongitude = String(lnglat.lat)
              AddApi(data).then((res) => {
                if(res.data.status == 200){
                  that.$message({
                    message: '添加数据成功',
                    type: 'success'
                  });
                  setTimeout(function(){
                    that.$router.push({path: '/bjent/list',query:{}});
                  },1000)
                }
              })
            } else {
              log.error('根据地址查询位置失败');
            }
          });
        }
      });
    },
    SplitStr(data){
      let Data = String(data).split('\n');
      this.Str  = '';
      for(let i=0;i<Data.length;i++){
        this.Str += '<p>'+ Data[i]+'</p>'
      }
      return this.Str;
    },
    handleSelect(val) {
      if(val == 1) {
        this.$router.push({path: '/ent/list',query:{}});
      } else{
        this.$router.push({path: '/bjent/list',query:{}});
      }
    }
  }
}
</script>

<style scoped>
  .el-menu-demo, .el-menu--horizontal, .el-menu {
    background: hsla(0,0%,100%,0)!important;
  }
  .el-menu--horizontal>.el-menu-item{
  padding: 0px 44px;
  font-size: 20px;
    height: 59px;
    line-height: 59px;
  }
  .el-menu-demo li {
    background: #BA0132 !important;
    color: white !important;
  }
  .el-menu-demo li:hover {
    background: #BA0132 !important;
  }
  .el-menu.el-menu--horizontal{
    border: none !important;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 1px solid white !important;
    background: #990012 !important;
  }
  .bodyDiv{
    /* background: rgb(240,221,223); */
    background: rgb(250,250,250);
  }
  .header{
    width: 100%;
    height: 60px;
    background: rgb(186,0,49);
  }
  .headCenter{
    height: 100%;
    display: flex;
    align-items: center;
    color: white;
    font-size: 24px;
    font-family: '方正正中黑简体';
  }
  .logo{
    width: 40px;
    height: 40px;
    display: flex;
    font-size: 14px;
    margin-right: 35px;
    border-radius: 4px;
    background: white;
    align-items: center;
    color: rgb(186,0,49);
    justify-content: center;
  }
  .logo img{
    width: 54px;
  }
  nav{
    height: 44px !important;
    border-bottom:  1px solid #DCDFE6;
    margin-bottom: 10px !important;
  }
  .Center1200{
    width: 1200px;
    margin: 0 auto;
  }
  .context{
    padding: 30px 0px;
    /* background: rgb(238,209,212); */
    background: white;
  }
  form{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  form .width45{
    width: 45%;
  }

  form .width90{
    width: 90%;
  }
  form .el-form-item__label{
    width: 100% !important;
  }
  .el-select{
    width: 100%;
  }
</style>
